import React, { useCallback } from 'react';
import {
  FieldInputProps,
  FormikHelpers,
}                             from 'formik';
import NumberFormat, {
  NumberFormatValues,
}                             from 'react-number-format';
import {
  TextField,
  BaseTextFieldProps,
}                             from '@material-ui/core';
import { TTextAlignProp }     from '@typings/components';

interface INumberFormatCustomProps {
  inputRef : (instance: NumberFormat | null) => void;
  onChange : (event: { target: { name: string; value?: number } }) => void;
  name     : string;
}

const NumberFormatCustom: React.FC<INumberFormatCustomProps> = (
  props: INumberFormatCustomProps,
): JSX.Element => {
  const { inputRef, onChange, ...other } = props;

  const handleOnValueChange = useCallback(
    (values: NumberFormatValues): void => {
      onChange({
        target: {
          name  : props.name,
          value : values.floatValue,
        },
      });
    },
    [onChange, props.name],
  );

  return (
    <NumberFormat
      {...other}
      getInputRef   = {(ref: NumberFormat | null): void => inputRef(ref)}
      onValueChange = {handleOnValueChange}
      thousandSeparator
      isNumericString
    />
  );
};

interface ICurrencyInputProps extends BaseTextFieldProps {
  form?              : FormikHelpers<any>;
  field?             : FieldInputProps<any>;
  width?             : string;
  textAlign?         : TTextAlignProp;
  variant?           : any;
  maxLength?         : number;
  prefix?            : string;
  suffix?            : string;
  decimalScale?      : number;
  fixedDecimalScale? : boolean;
  onChange?          : (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CurrencyInput: React.FC<ICurrencyInputProps> = ({
  form,
  field,
  width,
  onChange,
  textAlign,
  maxLength,
  prefix,
  suffix,
  decimalScale,
  fixedDecimalScale,
  ...props
}) => {
  const handleOnChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>): void => {
      if (!form || !field) return;

      form.setFieldValue(field.name, event.target.value);
    },
    [form, field],
  );

  return (
    <TextField
      {...field}
      {...props}
      onChange   = {onChange || handleOnChange}
      InputProps = {{
        inputComponent : NumberFormatCustom as any,
        style          : { width },
      }}
      inputProps = {{
        prefix,
        suffix,
        maxLength,
        decimalScale,
        fixedDecimalScale,
        style: { textAlign },
      }}
    />
  );
};

CurrencyInput.defaultProps = {
  prefix            : '$',
  width             : '120px',
  margin            : 'dense',
  variant           : 'outlined',
  textAlign         : 'right',
  fullWidth         : true,
  decimalScale      : 2,
  fixedDecimalScale : true,
};
